import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DrawerService {

  private drawerState: Subject<Boolean>;
  private mobileNavState: Subject<Boolean>;

  constructor() {
    this.drawerState = new Subject<Boolean>();
    this.mobileNavState = new Subject<Boolean>();
  }

  getDrawerState() {
    return this.drawerState.asObservable();
  }

  setDrawerState(state: Boolean) {
    this.drawerState.next(state);
  }

  getMobileNavDrawerState() {
    return this.mobileNavState.asObservable();
  }

  setMobileNAvDrawerState(state: Boolean) {
    this.mobileNavState.next(state);
  }
}
